<template>
  <div :class="has_errors ? 'has-errors' : ''" class="field">
    <label class="label">
      {{ label }}
    </label>
    <input :name="name" :value="country ? country.id : null" type="hidden"/>
    <Multiselect
      id="ajax"
      v-model="country"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="filtered"
      :multiple="false"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="true"
      :close-on-select="true"
      :options-limit="1000"
      :limit="1"
      :limit-text="limitText"
      :show-labels="false"
      label="name"
      track-by="id"
      :block-keys="['Delete']"
      @search-change="onSearch"
      @open="onOpen"
    >
      <template slot="option" slot-scope="props">
        <div class="level">
          <span class="level-left">
            {{ props.option.name }}
          </span>
          <span class="level-right"/>
        </div>
      </template>
      <span slot="noResult">
        Oops! No countries found. Consider changing the search query.
      </span>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Api from '../../helpers/Countries/Api';

export default {
  name: 'CountrySelect',

  components: {
    Multiselect
  },

  props: {
    name: { type: String, default: 'country' },
    value: { type: String, default: '' },
    has_errors: { type: Boolean, default: false },
    placeholder:{ type: String, default: 'Select...' },
    label:{ type: String, default: 'Country' }
  },

  data() {
    return {
      country: null,
      disabled: false,
      isLoading: false,
      countriesApi: new Api(),
      countries: [],
      filtered: []
    };
  },

  watch: {
    // this is needed to enable v-model functionality
    country(val) {
      this.$emit('input', val ? val.id : null);
    }
  },

  created() {
    this.disabled = true;
    this.isLoading = true;
    this.countriesApi
      .all()
      .then(response => {
        this.disabled = false;
        this.isLoading = false;

        const data = response.data.sort((a,b) => a.name.localeCompare(b.name));
        this.countries = data;
        this.filtered = data;

        if (this.value) {
          this.country = this.countries.filter((country) => country.id === this.value)[0];
        }
      });
  },

  methods: {
    limitText(count) {
      return `and ${count} other countries`;
    },

    onSearch: function (query) {
      const pattern = new RegExp('(' + query.toLowerCase() + ')', 'g');
      this.filtered = this.countries.filter((country) => country.id.toLowerCase().match(pattern));
    },

    onOpen: function () {
      this.country = null;
    }
  }
};
</script>
